<template>
  <div>
    <div class="vx-col w-full">
      <ul class="heading-ul mb-5">
        <li>
          <router-link to="/setup/usage-rating/rateplan" class="vx-row">
            <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            <h4>{{ $t("setup.label.UsageRateBalance") }}</h4>
          </router-link>
        </li>
      </ul>
    </div>
    <div class="vx-row">
      <vx-card title card-border>
        <table class="w-full mb-4">
          <tr>
            <td class="w-13">
              <b>{{ $t("setup.label.UOM") }}</b>
            </td>
            <td class="w-13">
              <b>{{ $t("setup.label.RUM") }}</b>
            </td>
            <td class="w-13">
              <b>{{ $t("setup.label.ImpactCategory") }}</b>
            </td>
            <td class="w-13">
              <b> {{ $t("setup.label.Resource") }}</b>
            </td>

            <td class="w-13">
              <b>{{ $t("setup.label.GLID") }}</b>
            </td>
            <td class="w-13">
              <b>{{ $t("setup.label.Unit") }}</b>
            </td>
            <td class="w-13">
              <b>{{ $t("setup.label.Rate") }}</b>
            </td>
            <td class="w-13">
              <b>{{ $t("setup.label.Action") }}</b>
            </td>
          </tr>
          <tr>
            <td class="w-13">
              <v-select
                label="uomName"
                v-model="price.uom"
                :options="ReportsData.UomDatas"
                :placeholder="$t('placeholder.label.SelectOne')"
              >
              </v-select>
            </td>
            <td class="w-13">
              <v-select
                label="rumName"
                v-model="price.rum"
                :options="ReportsData.RumDatas"
                :placeholder="$t('placeholder.label.SelectOne')"
              >
              </v-select>
            </td>
            <td class="w-13">
              <v-select
                label="mCodeValue"
                v-model="price.impact"
                :options="ReportsData.impactCategoryDatas"
                :placeholder="$t('placeholder.label.SelectOne')"
                :reduce="(obj) => obj.mCodeValue"
              >
              </v-select>
            </td>
            <td class="w-13">
              <v-select
                label="code"
                v-model="price.currencyId"
                :options="ReportsData.currencyDatas"
                :placeholder="$t('placeholder.label.SelectOne')"
              >
              </v-select>
            </td>

            <td class="w-13">
              <v-select
                label="id"
                v-model="price.glId"
                :options="ReportsData.glRealatedDatas"
                :placeholder="$t('placeholder.label.SelectOne')"
              >
                <!-- <template v-slot:option="option">{{
                      option.priceregion
                    }}</template> -->
              </v-select>
            </td>
            <td class="w-13">
              <vs-input
                class="w-full mb-2 font-semibold padding-zero"
                v-model="price.unit"
              />
            </td>
            <td class="w-13">
              <vs-input
                class="w-full mb-2 font-semibold padding-zero"
                v-model="price.price"
              />
            </td>
            <td class="w-13 pl-6">
              <feather-icon
                icon="PlusIcon"
                :title="$t('setup.label.Add')"
                svgClasses="w-5 h-5 hover:text-primary stroke-current cursor"
                @click.stop="addData()"
                class="icon_row"
              />
            </td>
          </tr>
          <tr></tr>
        </table>
        <hr />
        <table class="w-full mt-4 normal-table">
          <tr>
            <td>
              <b>{{ $t("setup.label.UOM") }}</b>
            </td>
            <td>
              <b>{{ $t("setup.label.RUM") }}</b>
            </td>
            <td>
              <b>{{ $t("setup.label.ImpactCategory") }}</b>
            </td>
            <td>
              <b> {{ $t("setup.label.Resource") }}</b>
            </td>

            <td>
              <b>{{ $t("setup.label.GLID") }}</b>
            </td>
            <td>
              <div style="margin: 9px 0">
                <b>{{ $t("setup.label.Unit") }}</b>
              </div>
            </td>
            <td>
              <b>{{ $t("setup.label.Rate") }}</b>
            </td>
            <td>
              <b>{{ $t("setup.label.Action") }}</b>
            </td>
          </tr>
          <tr v-for="(price, i) in priceList" :key="i">
            <td>
              <div style="margin: 9px 0">{{ price.uom.uomName }}</div>
            </td>
            <td>{{ price.rum.rumName }}</td>
            <td>{{ price.impact }}</td>
            <td>{{ price.currencyId.code }}</td>

            <td>{{ price.glId.id }}</td>
            <td>{{ price.unit }}</td>
            <td>{{ price.price }}</td>
            <td>
              <feather-icon
                icon="TrashIcon"
                :title="$t('setup.label.Delete')"
                svgClasses="w-5 h-5 text-danger stroke-current cursor"
                @click.stop="removePrice(i)"
                class="icon_row"
              />
            </td>
          </tr>
        </table>

        <div class="vx-row center mb-10">
          <div class="vx-col w-full">
            <vs-button
              color="primary"
              type="border"
              class="mb-2 footerButton-cancel"
              @click="$router.push('/CreateUsageRating')"
              >{{ $t("setup.label.Cancel") }}</vs-button
            >
            <vs-button
              class="mr-3 mb-2 footerButton-next"
              @click="editPrices"
              >{{ $t("setup.label.Submit") }}</vs-button
            >
          </div>
        </div>
      </vx-card>
    </div>

    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { mapState } from "vuex";

const ReportsEmptyObj = {
  planDesc: "",
  product: "",
  charge: "",
  rumName: "",
  eventRecordType: "",
  timeModelName: "",
  zoneType: "",
  regionDatas: [],
  stepName: "",
  startRange: "",
  endRange: "",
  resourceId: "",
  tierName: "",
  usageRateplanId: "",
};
const priceEmptyObj = {
  chargeCode: "",
  chargeOwner: "",
  chargevariant: "",
  currencyId: "",
  discountId: "",
  isPrepaid: "",
  locale: "en",
  planCode: "",
  price: "",
  priceregion: "",
  productId: "",
  duration: "",
  roundingType: "",
  glId: "",
  impact: "",
  uom: "",
  rum: "",
  unit: "",
};
export default {
  data() {
    return {
      timeList: [],
      priceList: [],
      Reports: { ...ReportsEmptyObj },
      warningPopup: false,
      warningText: "",
      editPopupYear: false,
      editJobsPopup: false,
      impactoptions: [
        "NationalRoamingCall",
        "InternationalZone1RoamingCall",
        "InternationalZone2RoamingCall",
        "LocalCall",
        "NationalCall	",
        "LocalSMS",
        "InternationalSMSIC",
      ],
      errorMessage: "",
      output: ["Continous", "Cumulative"],
      zoneoutput: [" Number", "APN", "Operator", "IC"],
      FieldType: [
        "Numeric",
        "VarChar",
        "TinyInt",
        "Decimal",
        "Text",
        "DateTime",
      ],
      Identifier: ["EventIdentifier", "ServiceIdentifier", "Default"],
      // warningPopup: false,
      // warningText: "",
      errorMessage: "",
      price: { ...priceEmptyObj },
      createPriceArray: [],
      editPriceArray: [],
      editPrice: { ...priceEmptyObj },
      priceTemplateData: {},
      chargeOwner: [
        { name: "Self", value: "self" },
        { name: "Parent", value: "parent" },
      ],
      prepaid: false,
      currencyCode: "",
      roundingTypes: [
        "RoundingUp",
        "RoundingDown",
        "RoundingHalf",
        "RoundingNearest",
      ],
      id: "",
      idPrice: "",
      // editToggle: false,
      pricingData: [],
      planData: [],
      productOptions: [],
      chargeCodes: [],
    };
  },
  components: {
    "v-select": vSelect,
  },
  computed: {
    ...mapState({
      ReportsData: (state) => state.usageRating.usageRateTemplate,
      timemodel: (state) => state.usageRating.timemodelList,
      priceByPlan: (state) => state.planPrice.priceWithTemplate,
      rateplancreate: (state) => state.usageRating.rateplancreate,
    }),
  },
  methods: {
    removePrice(i) {
      this.priceList.splice(i, 1);
    },

    async addData() {
      if (!this.price.currencyId || !this.price.price || !this.price.unit) {
        this.$swal({
          title: "Opps!",
          icon: "warning",
          text: "Please fill all required fields!",
          type: "warning",
        });
        return;
      }
      this.priceList = [...this.priceList, { ...this.price }];

      this.price = {
        chargeCode: "",
        chargeOwner: "",
        chargevariant: "",
        currencyId: "",
        discountId: "",
        isPrepaid: "",
        locale: "en",
        planCode: "",
        price: "",
        priceregion: "",
        productId: "",
        duration: "",
        roundingType: "",
        glId: "",
        impact: "",
        uom: "",
        unit: "",
      };
    },

    async editPrices() {
      const payload = {
        locale: "en",
        ratePlanId: this.Reports.planDesc.planId,
        ratebalance: [],
        usageRateplanId: this.id,
      };

      payload.ratebalance = this.priceList.map((el) => {
        return {
          currencyId: el.currencyId.id,
          glId: el.glId.id,
          uomId: el.uom.uomId,
          rumId: el.rum.rumId,
          unit: el.unit,
          rate: el.price,
          impactCategory: el.impact,
        };
      });
      try {
        await this.$store.dispatch(
          "usageRating/createUsageRateBalance",
          payload
        );

        this.$swal({
          title: "Success",
          icon: "success",
          text: "Update Successful!",
          type: "success",
        });
        this.$router.push("/setup/usage-rating/rateplan");
      } catch (e) {
        this.errorMessage = e.message.errors[0].defaultUserMessage.replace(
          "The parameter",
          ""
        );
        this.routeHold = true;
        this.warningPopup = true;
        this.errors = e.message.errors;
      }
    },
    async deletePrice(id) {
      await this.$store.dispatch("planPrice/deletePriceAction", id);
      this.getPriceWithTemplate();
    },
    cancel() {
      this.$router.push("/setup/usage-rating/rateplan");
    },

    planName() {
      this.productOptions = this.Reports.planDesc.products;
      this.chargeCodes = this.Reports.planDesc.chargeCodes;
      // this.Reports.product = this.Reports.planDesc.productDesc;
      // this.Reports.charge = this.Reports.planDesc.chargeCode;
    },

    async getFeemasterTemplate() {
      try {
        await this.$store.dispatch("usageRating/setUsageRateTemplate");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },

    cancel() {
      this.$router.push("/setup/usage-rating/rateplan");
    },

    resetForm() {
      this.Reports = { ...ReportsEmptyObj };
      this.price = { ...priceEmptyObj };
      this.editPrice = { ...priceEmptyObj };
      this.priceList = [];
    },
  },
  watch: {
    priceTemplateData(val) {
      this.price.planCode = val.serviceData[0].planCode;
      this.currencyCode = val.currencyCode;
      this.price.currencyId = val.currencyId;
      this.price.chargevariant = val.chargevariant[0].id;
      this.pricingData = val.pricingData;
      for (let temp of val.contractPeriods) {
        if (temp.id == val.duration) {
          this.prepaid = true;
          this.price.duration = temp.Contractdata;
          for (let temp2 of val.chargeData) {
            if (temp2.id == val.duration) {
              this.price.chargeCode = temp2.chargeCode;
            }
          }
          break;
        } else this.price.duration = "";
      }
    },
  },
  created() {},
  mounted() {
    this.resetForm();
    this.id = this.$route.params.id;
    this.getFeemasterTemplate();
  },
};
</script>
<style lang="scss">
// .popup-example {
//   table {
//     td {
//       vertical-align: top;
//       min-width: 100px;
//       padding-bottom: 0.8rem;
//       word-break: break-all;
//     }

//     &:not(.permissions-table) {
//       td {
//         @media screen and (max-width: 370px) {
//           display: block;
//         }
//       }
//     }
//   }
// }
.mid-popup .vs-popup {
  width: 1000px;
  max-width: 100%;
}
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border: solid 1px #f0f0f0;
}

.table td {
  vertical-align: middle;
  border-top: none;
  padding: 10px 7px;
  font-size: 14px;
  color: #646a71;
  border-bottom: 1px solid #dfe3e7;
  transition: all 0.2s ease;
  overflow: hidden;
  word-break: break-all;
}
.popup-example table td {
  vertical-align: middle;
}
.padding-zero {
  padding-top: 0px;
}
::v-deep .vs__selected-options {
  overflow: hidden;
  /* width: 100px; */
  font-size: 14px;
  display: block;
}
.price-table >>> .vs-input--input.normal {
  width: 60px;
  font-size: 14px;
}
.price-table >>> .vs-table-text {
  display: block !important;
}
.less-padding .vx-row > .vx-col {
  padding: 0 4px;
}
.footerButton-nextusage {
  width: 212px;
  height: 38px;
  top: 18px;
}
.w-13 {
  width: 13%;
  padding: 0 4px;
  max-width: 90px;
  &:last-child {
    width: 5%;
  }
}
.vs__selected-options {
  overflow: hidden;
}
.normal-table tr {
  td {
    &:not(:last-child) {
      border-right: 1px solid rgba(var(--vs-primary), 0.3);
    }
    border-bottom: 1px solid rgba(var(--vs-primary), 0.3);
  }

  text-align: center;
}
</style>
